import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from "reactstrap";
import Swal from "sweetalert2";
import { authHeader } from "../../../../services/fack.backend";
import LinkHealthInsurance from "../../../healthInsurance/link/linkHealthInsurance";
import ViewLinkedHealthInsurance from "../view/viewLinkedHealthInsurance";


const CreatePatient = (props) => {
  const { onCloseModal, fetchPatients } = props;

  const [name, setName] = useState('')
  const [errors, setErrors] = useState({})

  const [isOpenHealthInsuranceModal, setIsOpenHealthInsuranceModal] = useState(false)
  const [isOpenViewModal, setIsOpenViewModal] = useState(false)
  const [isOpenEditModal, setIsEditViewModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)


  const [healthInsurances, setHealthInsurances] = useState([])
  const [linkedHealthInsurances, setLinkedHealthInsurances] = useState([])
  const [singleInsurance, setSingleInsurance] = useState({})
  const [acomodationsToEdit, setAcomodationsToEdit] = useState([])


  useEffect(() => {
    fetchHealthInsurances();
  }, [])

  const isOpenHealthInsurance = () => {
    setIsOpenHealthInsuranceModal(true)
  };
  const onCloseHealthInsurance = () => {
    setIsOpenHealthInsuranceModal(false)
  };

  const onOpenViewModal = (value) => {
    setSingleInsurance(value)
    setIsOpenViewModal(true)
  }

  const onCloseViewModal = () => {
    setIsOpenViewModal(false)
  }

  const onOpenEditModal = (value) => {
    setSingleInsurance({ ...value, key: value.key })

    let includedNames = []

    Object.values(value.acomodations).map(response => {
      includedNames.push(response.description)
    })

    let temp = {
      columns: [
        {
          id: 1,
          title: 'Não Inclusas',
          cards: acomodations.columns[0].cards.filter(card => !includedNames.includes(card.description))
        },
        {
          id: 2,
          title: 'Inclusas',
          cards: value.acomodations
        },
      ]
    }
    setAcomodationsToEdit(temp)
    setIsEditViewModal(true)
  }

  const onCloseEditModal = () => {
    setIsEditViewModal(false)
  }



  const createPatient = async () => {
    if (name === "") {
      setErrors({
        name: 'Nome é obrigatório!'
      })
    } else if (linkedHealthInsurances.length === 0) {
      setErrors({
        linkedHealthInsurances: "É necessário vincular ao menos 1 convênio"
      })
    } else {
      setErrors({})
      const data = {
        name: name,
        healthInsurances: linkedHealthInsurances
      }

      axios.post(`${process.env.REACT_APP_API_URL}/api/patient/create`, data, { headers: authHeader() })
        .then(res => {
          onCloseModal()
          fetchPatients()
          Swal.fire('Paciente criado com sucesso!', '', 'success')
        }).catch(err => {

        })
    }
  }

  const getLinkedAcomodations = (data) => {
    const temp = linkedHealthInsurances.filter(insurance => insurance.key != data.key);
    temp.push({
      health_insurance: data.selectedInsurance[0],
      patient_insurance: {
        enrollment: data.enrollment
      },
      acomodations: data.acomodations,
      key: data.key
    });
    setLinkedHealthInsurances(temp);
    setErrors({})
  }

  const fetchHealthInsurances = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/api/healthInsurance/getAll`, { headers: authHeader() })
      .then(res => {
        setHealthInsurances(res.data)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
      })
  }

  const deleteLinkedHealthInsurance = async (value) => {
    const temp = []
    linkedHealthInsurances.map(v => {
      console.log(v, value)
      if (v !== value) {
        temp.push(v)
      }
    })
    setLinkedHealthInsurances(temp)
  }

  const acomodations = {
    columns: [
      {
        id: 1,
        title: 'Não Inclusas',
        cards: [
          {
            id: 3,
            description: 'Ambulatório'
          },
          {
            id: 4,
            description: 'Apartamento'
          },
          {
            id: 5,
            description: 'Enfermaria'
          },
        ]
      },
      {
        id: 2,
        title: 'Inclusas',
        cards: []
      },
    ]
  }

  return (
    <div>
      <Modal isOpen={isOpenHealthInsuranceModal} size="lg">
        <LinkHealthInsurance
          onCloseModal={onCloseHealthInsurance}
          acomodations={acomodations}
          getLinkedAcomodations={(data) => getLinkedAcomodations(data)}
          healthInsurances={healthInsurances}
          isEdit={false}
        />
      </Modal>

      <Modal isOpen={isOpenViewModal} size="sm">
        <ViewLinkedHealthInsurance
          onCloseModal={onCloseViewModal}
          singleInsurance={singleInsurance}
        />
      </Modal>

      <Modal isOpen={isOpenEditModal} size="lg">
        <LinkHealthInsurance
          onCloseModal={onCloseHealthInsurance}
          acomodations={acomodationsToEdit}
          getLinkedAcomodations={(data) => getLinkedAcomodations(data)}
          healthInsurances={healthInsurances}
          isEdit={true}
          singleInsurance={singleInsurance}
          onCloseEditModal={onCloseEditModal}
        />
      </Modal>
      <ModalHeader toggle={onCloseModal}>
        <h5>{'Cadastrar Paciente'}</h5>
      </ModalHeader>
      {isLoading ?
        <div className="loader-box">
          <div className="loader-7"></div>
        </div>
        :
        <ModalBody>
          <Container fluid={true}>
            <Form>
              <Row>
                <Col>
                  <Label className="col-form-label">{"Nome:"}</Label>
                  <Input className="form-control" type="text" onChange={(e) => setName(e.target.value)} />
                  <span className="font-danger">{errors.name}</span>
                </Col>
              </Row>
              <br />
              {linkedHealthInsurances.length > 0 &&
                <div className="table-responsive">
                  <Table className="table-border-horizontal">
                    <thead>
                      <tr>
                        <th scope="col">{"Convênio"}</th>
                        <th scope="col">{"Matrícula"}</th>
                        <th scope="col">{""}</th>
                        <th scope="col">{""}</th>
                      </tr>
                    </thead>
                    {linkedHealthInsurances.map((value, key) => (
                      <tbody>
                        <tr key={key}>
                          <td>{value.health_insurance.name}</td>
                          <td>{value.patient_insurance.enrollment}</td>
                          <td>
                            <i id="look-button" className="fa fa-eye" onClick={() => onOpenViewModal(value)} style={{ cursor: "pointer" }}></i>
                          </td>
                          <td>
                            <i id={`edit-button`} className="fa fa-pencil" onClick={() => onOpenEditModal(value)} style={{ cursor: "pointer" }}></i>
                          </td>
                          <td>
                            <i id={`delete-button`} className="fa fa-trash-o" onClick={() => deleteLinkedHealthInsurance(value)} style={{ cursor: "pointer" }}></i>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </Table>
                </div>
              }
              <br />
              <Row className="text-center">
                <Col className="col-12">
                  <Button color="success" onClick={() => isOpenHealthInsurance()}><i className="fa fa-plus"></i> Vincular Convênio</Button>
                </Col>
                <span className="font-danger">{errors.linkedHealthInsurances}</span>
              </Row>
            </Form>
            <br />
            <ModalFooter>
              <Button color="primary" className="float-right" onClick={() => createPatient()} >{'Criar'}</Button>
            </ModalFooter>
          </Container>
        </ModalBody>
      }
    </div>
  )
}

export default CreatePatient;